import React from 'react';
import { Route } from 'react-router';
import Ingredient, { Library, Category, Recipes } from 'pages/Ingredient';
import createCustomRoute from 'hocs/createCustomRoute';

const IngredientRoutes = createCustomRoute('IngredientRoutes', props => (
  <Route {...props} component={Ingredient}>
    <Route path="list" component={Library} />
    <Route path="categories" component={Category} />
    <Route path="recipes" component={Recipes} />
  </Route>
));

export default IngredientRoutes;
